import getConfig from "next/config";

import { EntityInput, LinkProps, isURLAbsolute } from "helpers/url";

const { publicRuntimeConfig } = getConfig();
const { BLOG_URL } = publicRuntimeConfig;

export function articleHref(
  entity: EntityInput,
  origin?: string
): LinkProps["href"] {
  return articleAs(entity, origin);
}

export function articleAs(
  entity: EntityInput,
  origin?: string
): LinkProps["as"] {
  if (entity?.url) {
    if (isURLAbsolute(entity.url)) return entity.url;
    const url = entity.url.startsWith("/") ? entity.url : `/${entity.url}`;
    const currentUrl = url.endsWith("/") ? url : `${url}/`;

    if (origin) {
      return `${origin}${currentUrl}`;
    }

    return currentUrl;
  }

  if (entity?.alias) {
    const url = `${BLOG_URL}${entity.alias}/`;
    if (origin) return `${origin}${url}`;

    return url;
  }

  if (origin) return `${origin}${BLOG_URL}`;

  return BLOG_URL;
}
